import { render, staticRenderFns } from "./CalendarYear.vue?vue&type=template&id=4fbee0b4&"
import script from "./CalendarYear.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarYear.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports